module.exports = __webpack_public_path__ + "static/media/printer.7bc8b159.svg";